import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../../UI/addForm.css";

import global from "../../config";
import Card from "../../UI/Card";
import "./playComponent.scss";

import Header from "../Header/Header";
import "./ManageAssets.css";

import Loader from "../../UI/Loader";
import ConfirmationDialog from "../../UI/ConfirmationDialog";

export default function AssetDetails(props) {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [listData, setListData] = useState({});

  const [submitSearch, showSubmitSearch] = useState(false);
  const [addFormDialog, setAddFormDialog] = useState(false);

  const [records, setRecords] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [percentagePackaged, setPercentagePackaged] = useState(0);
  const [percentageMetaData, setPercentageMetaData] = useState(0);
  const [videoTitle, setVideoTitle] = useState("");
  const [editMode, setEditMode] = useState(false);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [entityType, setEntityType] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [genreSrc, setGenreSrc] = useState("");
  const [ratingSrc, setRatingSrc] = useState("");
  const [directors, setDirectors] = useState("");
  const [producers, setProducers] = useState("");
  const [internalTitle, setInternalTitle] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [keywords, setKeywords] = useState("");
  const [cutPoints, setCutPoints] = useState("");
  const [genreVal, setGenreVal] = useState("");
  const [ratingVal, setRatingVal] = useState("");
  const [actors, setActors] = useState("");
  const [metadata, setMetadata] = useState(false);

  const [formSubmitError, setFormSubmitError] = useState(false);

  const { assetID } = useParams();

  // [Start of Context Menu Option]

  const [toggleActionBlock, setToggleAction] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const toggleAction = () => {
    setToggleAction(!toggleActionBlock);
  };

  const onCancelClick = () => {
    setShowConfirm(false);
    setFormSubmitError(false);
  };

  const editForm = (userID) => {
    setAddFormDialog(!addFormDialog);
  };

  const txtValue = (e) => {
    if (e.target.name === "txtTitle") {
      setTitle(e.target.value);
    }
    if (e.target.name === "txtDescription") {
      setDescription(e.target.value);
    }
    if (e.target.name === "txtShortDescription") {
      setShortDesc(e.target.value);
    }
    if (e.target.name === "txtEntityType") {
      setEntityType(e.target.value);
    }
    if (e.target.name === "txtDateRelease") {
      setReleaseDate(e.target.value);
    }
    if (e.target.name === "txtGenreSrc") {
      setGenreSrc(e.target.value);
    }
    if (e.target.name === "txtRatingSrc") {
      setRatingSrc(e.target.value);
    }
    if (e.target.name === "txtDirectors") {
      setDirectors(e.target.value);
    }
    if (e.target.name === "txtProducers") {
      setProducers(e.target.value);
    }
    if (e.target.name === "txtInternalTitle") {
      setInternalTitle(e.target.value);
    }
    if (e.target.name === "txtKeywords") {
      setKeywords(e.target.value);
    }
    if (e.target.name === "txtCutPoints") {
      setCutPoints(e.target.value);
    }
    if (e.target.name === "txtGenreVal") {
      setGenreVal(e.target.value);
    }
    if (e.target.name === "txtRatingVal") {
      setRatingVal(e.target.value);
    }
    if (e.target.name === "txtActors") {
      setActors(e.target.value);
    }
  };
  const clickSerach = () => {
    setShowLoader(true);
    showSubmitSearch(true);
  };
  const keyUpSearch = (e) => {
    if (e.target.value.length === 0 || e.key === "Enter") {
      clickSerach();
    }
  };

  const getData = async () => {
    const idToken = localStorage.getItem("idToken");
    let payLoad = { operation: "list" };

    if (assetID) {
      payLoad = { operation: "getVideoDetails", videoId: assetID };
    }

    if (idToken) {
      const response = await axios.post(global.apiURL + "/videos/", payLoad, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        setVideoTitle(response.data.data?.video_title);
        setTitle(response.data.data?.video_title);
        setListData([response.data.data]);
        setRecords([response.data.data]);

        setInternalTitle(response.data.data?.internalTitle);
        setDescription(response.data.data?.description);
        setShortDesc(response.data.data?.shortDesc);
        setEntityType(response.data.data?.entryType);
        setKeywords(response.data.data?.keywords);
        setReleaseDate(response.data.data?.releaseDate);
        setCutPoints(response.data.data?.cutPoints);
        setGenreSrc(response.data.data?.genreSource);
        setGenreVal(response.data.data?.genreValue);
        setRatingSrc(response.data.data?.ratingSource);
        setRatingVal(response.data.data?.ratingValue);
        setDirectors(response.data.data?.directors);
        setProducers(response.data.data?.producers);
        setActors(response.data.data?.actors);
        setMetadata(response.data.data?.metadata);
      } else {
        navigate("/");
      }
    }

    setShowLoader(false);
    showSubmitSearch(false);
  };

  useEffect(() => {
    getData();
  }, [submitSearch]);

  useEffect(() => {
    let sumCount = 0;
    let sumAssets = 0;
    let sumFileSize = 0;
    let sumDuration = 0;
    let countPackaged = 0;
    let countMetaData = 0;
    if (records && records.length > 0) {
      records.forEach((record) => {
        sumCount = sumCount + 1;
        sumFileSize +=
          parseFloat(record.fileSize) > 0 ? parseFloat(record.fileSize) : 0;
        sumDuration +=
          parseFloat(record.duration) > 0 ? parseFloat(record.duration) : 0;
        if (
          record.video_filename &&
          record.thumbnail_filename &&
          record.transcript_filename
        )
          countPackaged++;
        if (record.ShowMetaData) countMetaData++;
      });
    }
    setTotalRecord(sumCount);
    setTotalAssets(sumAssets);
    setTotalFileSize(sumOfFileSizes([sumFileSize]));
    setTotalDuration(sumOfCreatorDuration([sumDuration]));
    setPercentagePackaged(((countPackaged / records.length) * 100).toFixed(2));
    setPercentageMetaData(((countMetaData / records.length) * 100).toFixed(2));
  }, [records]);

  const sumOfFileSizes = (fileSizes) => {
    if (!fileSizes || fileSizes.length === 0) {
      return 0;
    }
    const sumInBytes = fileSizes.reduce(
      (acc, size) => acc + parseInt(size, 10),
      0
    );
    const bytesPerGB = 1073741824;
    const sumInGB = sumInBytes / bytesPerGB;
    return Number(sumInGB.toFixed(2));
  };

  const sumOfCreatorDuration = (durations) => {
    // if (!durations || durations.length === 0) {
    //   return "0 mins";
    // }
    const sumInSeconds = durations;

    const hours = Math.floor(sumInSeconds / 3600);
    const minutes = Math.floor((sumInSeconds % 3600) / 60);

    if (hours === 0) {
      return `${minutes} mins`;
    } else {
      return `${hours} hrs ${minutes} mins`;
    }
  };

  const convertToMbps = (bitrateBps) => {
    const bitsPerMegabit = 1024 * 1024;
    return Math.ceil((bitrateBps / bitsPerMegabit) * 100) / 100;
  };

  const convertFPS = (frameRate) => {
    const rate = frameRate.split("/");
    return rate[0];
  };

  const editClik = () => {
    setEditMode(!editMode);
  };

  const clickSubmit = async () => {
    let formError = false;
    setFormSubmitError(false);

    if (!description || !shortDesc || !title || !internalTitle) {
      setFormSubmitError(true);
      formError = true;
    }
    if (!formError) {
      setShowLoader(true);
      setEditMode(false);
    }
    const idToken = localStorage.getItem("idToken");
    let payLoad = { operation: "editVideo" };

    if (assetID) {
      payLoad = {
        operation: "edit",
        VideoId: assetID,
        description: description,
        shortDesc: shortDesc,
        video_title: title,
        internalTitle: internalTitle,
        entryType: entityType,
        keywords: keywords,
        releaseDate: releaseDate,
        cutPoints: cutPoints,
        genreSource: genreSrc,
        genreValue: genreVal,
        ratingSource: ratingSrc,
        ratingValue: ratingVal,
        directors: directors,
        producers: producers,
        actors: actors,
      };
    }

    if (idToken && !formError) {
      const response = await axios.post(global.apiURL + "/videos/", payLoad, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        getData();
        setShowLoader(false);
      } else {
        navigate("/");
      }
    }
  };

  const entityTypesArr = [
    {
      name: "Series",
      value: "Series",
    },
    {
      name: "Short Form Video",
      value: "Short Form Video",
    },
    {
      name: "TV Special",
      value: "TV Special",
    },
    {
      name: "Movie",
      value: "Movie",
    },
  ];

  const genreSrcArr = [
    {
      name: "Neilsen",
      value: "Neilsen",
    },
    {
      name: "Wurl",
      value: "Wurl",
    },
    {
      name: "Roku",
      value: "Roku",
    },
  ];
  const genreValArr = [
    {
      name: "Evening Comedy",
      value: "Evening Comedy",
    },
  ];
  const ratingSrcArr = [
    {
      name: "MPAA",
      value: "MPAA",
    },
    {
      name: "ICAA",
      value: "ICAA",
    },
    {
      name: "Samsung",
      value: "Samsung",
    },
  ];
  const ratingValArr = [
    {
      name: "TV-14",
      value: "TV-14",
    },
  ];

  return (
    <>
      <div className="wrap-over-container">
        <Header />
        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader">
                <h3>{`Assets > ${videoTitle}`}</h3>
                <div className="admin-panel-header-right">
                  <button onClick={editClik}>
                    {editMode === false ? (
                      <i className="learning-icon icon-edit">&#xe905;</i>
                    ) : (
                      "Cancel"
                    )}
                  </button>
                </div>
              </div>
              <div className="adbody">
                {showLoader === true && (
                  <div style={{ height: "70vh", position: "relative" }}>
                    <Loader />
                  </div>
                )}

                {formSubmitError && (
                  <ConfirmationDialog
                    title="Error Updating the Asset"
                    description={`Please enter all mandatory fields`}
                    onSubmitClick={onCancelClick}
                    submitButtonText="Close"
                  />
                )}

                {showLoader === false && (
                  <>
                    {listData.map((data, index) => (
                      <div key={data._id}>
                        <Card type="header">
                          <div className="asset-details-container-half">
                            <div className="asset-details-items">
                              <div className="card-column-stats">
                                {totalFileSize} GB <br /> FILESIZE
                              </div>
                              <div className="card-column-stats">
                                {totalDuration} <br /> DURATION
                              </div>
                              <div className="card-column-stats">
                                {percentageMetaData}% <br /> COMPLETE
                              </div>
                              <div className="card-column-stats">
                                {data.width}p <br /> RESOLUTION
                              </div>
                            </div>

                            <div className="video_metadata_continer">
                              <div className="video_metadata_key">CREATOR:</div>
                              <div className="video_metadata_value">
                                {data.CreatorName}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">SHOW:</div>
                              <div className="video_metadata_value">
                                {data.ShowName}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">SEASON:</div>
                              <div className="video_metadata_value">
                                {data.season ? data.season : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">EPISODE:</div>
                              <div className="video_metadata_value">
                                {data.episode ? data.episode : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_value d-flex">
                                <span>
                                  THUMB
                                  {data.thumbnail_filename && (
                                    <i className="learning-icon icon-yes">
                                      &#xe901;
                                    </i>
                                  )}
                                  {!data.thumbnail_filename && (
                                    <i className="learning-icon icon-no">
                                      &#xe900;
                                    </i>
                                  )}
                                </span>
                                <span>
                                  CC
                                  {data.transcript_filename && (
                                    <i className="learning-icon icon-yes">
                                      &#xe901;
                                    </i>
                                  )}
                                  {!data.transcript_filename && (
                                    <i className="learning-icon icon-no">
                                      &#xe900;
                                    </i>
                                  )}
                                </span>
                                <span>
                                  METADATA
                                  {metadata && (
                                    <i className="learning-icon icon-yes">
                                      &#xe901;
                                    </i>
                                  )}
                                  {!metadata && (
                                    <i className="learning-icon icon-no">
                                      &#xe900;
                                    </i>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="asset-details-container-half">
                            <div className="player-container">
                              <div className="player-box">
                                <video width="100%" height="200" controls>
                                  {/* <source
                                    src={`https://samplelib.com/lib/preview/mp4/sample-5s.mp4`}
                                    type={`video/mp4`}
                                  />
                                   */}
                                  <source src={data.URL} type={`video/mp4`} />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            </div>
                          </div>

                          <div className="clear"></div>
                        </Card>
                        <Card className="adheader">
                          <div className="asset-details-container-half">
                            <div className="video_metadata_continer">
                              <div className="video_metadata_key add-dialog-form-group">
                                <label>
                                  {" "}
                                  TITLE:<span className="required">*</span>
                                </label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.video_title}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtTitle"
                                    id="txtTitle"
                                    placeholder="Enter Title"
                                    value={title}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>
                                  DESCRIPTION:{" "}
                                  <span className="required">*</span>
                                </label>
                              </div>

                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.description ? data.description : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtDescription"
                                    id="txtDescription"
                                    placeholder="Enter Description"
                                    value={description}
                                  />
                                </div>
                              )}

                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>ENTITY TYPE:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.entryType ? data.entryType : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <select
                                    id="txtEntityType"
                                    name="txtEntityType"
                                    onChange={txtValue}
                                    defaultValue={entityType}
                                  >
                                    <option key="NA" value="">
                                      Select Entity Type
                                    </option>
                                    {entityTypesArr.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        defaultValue={e.value === entityType}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>RELEASE DATE:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.releaseDate ? data.releaseDate : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtDateRelease"
                                    id="txtDateRelease"
                                    placeholder="Enter Release Date"
                                    value={releaseDate}
                                  />
                                </div>
                              )}

                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label> GENRE SRC:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.genreSource ? data.genreSource : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <select
                                    id="txtGenreSrc"
                                    name="txtGenreSrc"
                                    onChange={txtValue}
                                    defaultValue={genreSrc}
                                  >
                                    <option key="NA" value="">
                                      Select Genre Src
                                    </option>
                                    {genreSrcArr.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        defaultValue={e.value === genreSrc}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>RATING SRC:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.ratingSource ? data.ratingSource : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <select
                                    id="txtRatingSrc"
                                    name="txtRatingSrc"
                                    onChange={txtValue}
                                    defaultValue={ratingSrc}
                                  >
                                    <option key="NA" value="">
                                      Select Rating Src
                                    </option>
                                    {ratingSrcArr.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        defaultValue={e.value === ratingSrc}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>DIRECTORS:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.directors ? data.directors : "--"}
                                </div>
                              )}

                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtDirectors"
                                    id="txtDirectors"
                                    placeholder="Enter Director"
                                    value={directors}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>PRODUCERS:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.producers ? data.producers : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtProducers"
                                    id="txtProducers"
                                    placeholder="Enter Producers"
                                    value={producers}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>
                            </div>
                          </div>
                          <div className="asset-details-container-half">
                            <div className="video_metadata_continer">
                              <div className="video_metadata_key add-dialog-form-group">
                                <label>
                                  INT TITLE:<span className="required">*</span>
                                </label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.internalTitle
                                    ? data.internalTitle
                                    : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtInternalTitle"
                                    id="txtInternalTitle"
                                    placeholder="Enter Internal Title"
                                    value={internalTitle}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>
                                  SHORT DESC:<span className="required">*</span>
                                </label>
                              </div>

                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.shortDesc ? data.shortDesc : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtShortDescription"
                                    id="txtShortDescription"
                                    placeholder="Enter Short Description"
                                    maxLength="110"
                                    value={shortDesc}
                                  />
                                </div>
                              )}

                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>KEYWORDS:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.keywords ? data.keywords : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtKeywords"
                                    id="txtKeywords"
                                    placeholder="Enter Keywords"
                                    value={keywords}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>CUT POINTS:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.cutPoints ? data.cutPoints : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtCutPoints"
                                    id="txtCutPoints"
                                    placeholder="Enter Cut Points"
                                    value={cutPoints}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>GENRE VAL:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.genreValue ? data.genreValue : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <select
                                    id="txtGenreVal"
                                    name="txtGenreVal"
                                    onChange={txtValue}
                                    defaultValue={genreVal}
                                  >
                                    <option key="NA" value="">
                                      Select Gnre Val
                                    </option>
                                    {genreValArr.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        defaultValue={e.value === genreVal}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>RATING VAL:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.ratingValue ? data.ratingValue : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <select
                                    id="txtRatingVal"
                                    name="txtRatingVal"
                                    onChange={txtValue}
                                    defaultValue={ratingVal}
                                  >
                                    <option key="NA" value="">
                                      Select Rating Val
                                    </option>
                                    {ratingValArr.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        defaultValue={e.value === ratingVal}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div className="clear"></div>

                              <div className="video_metadata_key add-dialog-form-group">
                                <label>ACTORS:</label>
                              </div>
                              {editMode === false && (
                                <div className="video_metadata_value">
                                  {data.actors ? data.actors : "--"}
                                </div>
                              )}
                              {editMode === true && (
                                <div className="video_metadata_value add-dialog-form-group">
                                  <input
                                    type="text"
                                    onChange={txtValue}
                                    name="txtActors"
                                    id="txtActors"
                                    placeholder="Enter Actors"
                                    value={actors}
                                  />
                                </div>
                              )}
                              <div className="clear"></div>
                            </div>
                          </div>
                        </Card>

                        <Card>
                          <div className="asset-details-container-half">
                            <div className="video_metadata_continer">
                              <div className="video_metadata_key">
                                DURATION:
                              </div>
                              <div className="video_metadata_value">
                                {totalDuration}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">
                                FILESIZE:
                              </div>
                              <div className="video_metadata_value">
                                {totalFileSize} GB
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">BITRATE:</div>
                              <div className="video_metadata_value">
                                {data.bitrate
                                  ? convertToMbps(data.bitrate) + " MBPS"
                                  : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">
                                FRAME RATE:
                              </div>
                              <div className="video_metadata_value">
                                {data.framerate
                                  ? convertFPS(data.framerate) + " FPS"
                                  : "--"}
                              </div>
                              <div className="clear"></div>
                            </div>
                          </div>
                          <div className="asset-details-container-half">
                            <div className="video_metadata_continer">
                              <div className="video_metadata_key">
                                SAMPLE RATE:
                              </div>
                              <div className="video_metadata_value">
                                {data.samplingrate ? data.samplingrate : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">
                                CHANNELS:
                              </div>
                              <div className="video_metadata_value">
                                {data.channels ? data.channels : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">HEIGHT:</div>
                              <div className="video_metadata_value">
                                {data.height ? data.height + " px" : "--"}
                              </div>
                              <div className="clear"></div>

                              <div className="video_metadata_key">WIDTH:</div>
                              <div className="video_metadata_value">
                                {data.width ? data.width + " px" : "--"}
                              </div>
                              <div className="clear"></div>
                            </div>
                          </div>
                        </Card>
                        {editMode === true && (
                          <Card>
                            <div className="add-dialog-footer">
                              <button
                                type="button"
                                className="add-dialog-submit"
                                onClick={clickSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </Card>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
